export default "__VITE_ASSET__Nrl9mTwQ__"